import './abstract_section_view.coffee'
Namespace('Monitoring.Reports.Executive')

class Monitoring.Reports.Executive.ChannelInteractionEngagment extends Monitoring.Reports.Executive.AbstractSectionView
  id: 'channel-interactions-egmnt'
  name: 'channel-interactions-egmnt-table'
  tagName: 'section'
  template: JST["backbone/templates/monitoring/reports/executive/generic_template"]
  chartClass: 'channel-interacions-egmnt-table'

  initialize: (@options = {}) ->
    @columns = ['', 'Periodo Seleccionado', "Engagment rate" ]
    @labels = {likes: "Likes", comments: "Comments", shares: "Shares", link_clicks: "Link clicks", video_plays: "Video play", total: "Total"}

  render: ->
    @specific_settings ||= {}

    @specific_settings.benchmark = true
    @$el.html(@template(self: this))
    @bindChartsReady(1)
    @_getTable().addClass('processing')
    query = @labelsQuery(@labelFilter(), @labelsStructure())
    fb_page = @getTemplateOptions().page

    @setBenchmarkSettingsIfNecessary(query)
    $.post(@options.chartApi.channel_interactions_engagement + @getTemplateOptions().network , _.extend({page: fb_page}, query, @getExtraQuery()), (response) =>
      tableData = { columns: @columns, data: [], types: ['string', 'number','string'], options: {} }
      for k,v of response
        tableData.data.push([@labels[k] || k, v["count"], v["egmnt_rate"]])
      @_getTable().html(new Monitoring.Reports.Executive.TableView(response: tableData).render().el)
    )
    return this

  _getTable: ->
    @$el.find(".#{@chartClass}")
